export default __webpack_public_path__ + "static/media/FOTO8.4625e1bc.jpg";